export const EXPANDED_SIZE = 280;
export const SMALL_SIZE = 140;

export const INITIAL_SIZE_VIDEO = { width: 280, height: 280 };
export const MIN_SIZE_VIDEO = { width: 280, height: 280 };
export const MAX_SIZE_VIDEO = { width: 800, height: 800 };
export const SIZE_AVATAR = { width: 140, height: 140 };
